










































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LoaderMixin from "@/mixins/loader";
import Submissions from "@/components/admin/Submissions.vue";
import { logOut } from "@/services/authentication";

@Component({
  components: {
    Submissions
  }
})
export default class MyAccount extends mixins(LoaderMixin) {
  private drawer: any = null;

  private signOut() {
    logOut();
    this.$router.push("/");
  }

  get isAdminOrProofreader() {
    return this.$store.state.user.type !== "user";
  }
}
